import { User } from "./user"; 

export const GuestLogAction = {
	INVITE: "invite",
	UPDATE: "update",
	DELETE: "delete",
	REMOVE: "remove",
	ARRIVED: "arrived",
	APPROVE: "approve",
	DECLINE: "decline",
	SIGN_IN: "sign-in",
	SIGN_OUT: "sign-out",
};
export interface RequestedService {
	id: any;
	name: string;
	code: string;
	type: any;
	typeId: number;
	duration: number;
	quantity: number;
}

export interface QueueLogComment {
	value: string;
	authorId: number;
	author: {
		type: string;
		name: string;
	}
}

export class QueueLog {
	public static STATUS = {
		QUEUED: "QD", 
		PROCESSING: "PR", 
		SIGNOUT_PENDING: "SP",
		
		SIGNED_IN: 'SI',
		SIGNED_OUT: 'SO',
		NOT_ARRIVED: "NA",
		APPROVAL_PENDING: 'AP',
		APPROVAL_GRANTED: 'AG',
		APPROVAL_DECLINED: 'AD',
		DELETED: 'DL'
	}
	public static HOST_TYPE = {
		USER: "U",
		GROUP: "G"
	}
	public static LOG_TYPE = {
		BOOKING: "BK",
		WALK_IN: "WI",
		EXTRA: "EX"
	}

	id: any;
	hostId: any;
	hostType: string;
	hostInitials?: string;
	hostName: string;
	creationDate: any;
	sortDate: any;
	guestId: any;
	guestInitials?: string;
	guestName: string;
	guestPhone: string;
	guestEmail: string;
	guestAddress: string;
	guestPhoto: string;
	requestedServiceIds?: any[];
	bookingPin: string;
	expectedTime: string;
	arrivalTime: string;
	approvalTime: string;
	timeIn: string;
	processEndTime?: string;
	processEndComment?: QueueLogComment | null;
	timeOut: string;
	tagNumber: string;
	status: string;
	logType: string;
	hasSeen: boolean;
	isPrivate: boolean;
	requireApproval: boolean;

	creatorId?: string;
	receiver?: User;
	receiverId: number;
	receiverName?: string;
	releaserId?: number;
	releaserName?: string;

	serviceStationId?: number;
	serviceRating?: number | null;
	serviceComment?: QueueLogComment | null;

	subLocationId: number;
	locationId: number;
	clientId: number;

	lastModified: string;

	expectedTimestamp: any;
	arrivalTimestamp: any;
	approvalTimestamp: any;
	processEndTimestamp: any;
	inTimestamp: any;
	outTimestamp: any;
	modTimestamp: any;
	userIsHost?: boolean;
	requestedServices?: RequestedService[];

	qrData: any;

	constructor(
		id: any,
		hostId: any,
		hostType: string,
		hostName: string,
		creationDate: any,
		sortDate: any,
		guestId: string,
		guestName: string,
		guestPhone: string,
		guestEmail: string,
		guestAddress: string,
		guestPhoto: string,
		bookingPin: string,
		expectedTime: string,
		arrivalTime: string,
		approvalTime: string,
		timeIn: string,
		timeOut: string,
		tagNumber: string,
		status: string,
		logType: string,
		hasSeen: boolean,
		isPrivate: boolean,
		requireApproval: boolean,
		receiverId: number,
		locationId: number,
		subLocationId: number,
		clientId: number,
		lastModified: string
	) {
		this.id = id;
		this.hostId = hostId;
		this.hostType = hostType;
		this.hostName = hostName;
		this.creationDate = creationDate;
		this.sortDate = sortDate;
		this.guestId = guestId;
		this.guestName = guestName;
		this.guestPhone = guestPhone;
		this.guestEmail = guestEmail;
		this.guestAddress = guestAddress;
		this.guestPhoto = guestPhoto;
		this.bookingPin = bookingPin;
		this.expectedTime = expectedTime;
		this.arrivalTime = arrivalTime;
		this.approvalTime = approvalTime;
		this.timeIn = timeIn;
		this.timeOut = timeOut;
		this.tagNumber = tagNumber;
		this.status = status;
		this.logType = logType;
		this.hasSeen = hasSeen;
		this.isPrivate = isPrivate;
		this.requireApproval = requireApproval;
		this.receiverId = receiverId;
		this.locationId = locationId;
		this.subLocationId = subLocationId;
		this.clientId = clientId;
		this.lastModified = lastModified;
	}
}
